import { z } from 'zod'
import { npoShape } from '../npo'
import { readonly } from '@thinknimble/tn-models'
import { baseModelShape } from '../baseModel'
import { frequencyShape } from '../frequencies'
import { canvassingOrgShape, userShape } from '../users'

export const paymentProviderShape = {
  id: z.string().uuid(),
  formId: z.string().or(z.number()),
  levelId: z.string().or(z.number()),
  paymentProvider: z.string().or(z.number()),
  paymentProviderName: readonly(z.string().optional().nullable()),
  campaign: z.string().uuid(),
  customDomain: z.string().nullable(),
  environmentId: z.string().nullable().optional(),
  paymentConfigurationId: z.string().nullable().optional(),
  checkoutZone: z.string().nullable().optional(),
  recaptchaSiteKey: z.string().nullable().optional(),
}

export const campaignShape = {
  ...baseModelShape,
  name: z.string(),
  frequencies: z.array(z.object(frequencyShape)),
  npo: z.object(npoShape),
  fundraisers: z.array(z.object(userShape)),
  background: z.string().url().nullable(),
  latestPaymentProvider: z.object(paymentProviderShape).nullable(),
  testMode: z.boolean(),
  active: z.boolean(),
  collectingLeads: z.boolean(),
  collectingDonations: z.boolean(),
  stopCountEnabled: z.boolean(),
  donorVerificationEnabled: z.boolean(),
  qrCodeOnlyEnabled: z.boolean(),
  canvassingOrg: z.object(canvassingOrgShape),
  location: z.string(),
  timezone: z.string().optional().default('America/New_York'),
}

export const campaignRetrieveShape = {
  campaign: z.string(),
  // A donor device has no login, so it identifies itself with the signed grant from the
  // link it arrived on. legacyFundraiser only covers links sent before grants shipped.
  formToken: z.string().nullish(),
  legacyFundraiser: z.string().nullish(),
}

export const campaignUpdateShape = {
  id: z.string(),
  fundraisers: z.array(z.string()).optional(),
  stopCountEnabled: z.boolean().optional(),
}

export const canvassingOrgAdminChartInputShape = {
  start_date: z.string(),
  end_date: z.string(),
  campaign_filter_value: z.string(),
}

export const storeCampaignDataFilterTemplateShape = {
  name: z.string(),
  filterType: z.string(),
  campaign: z.string().uuid(),
  fundraiser: z.string(),
  homeOffice: z.string(),
}
